import { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

interface RequirePermissionProps {
  permission: string
  children: ReactNode
  /** Where to send users who lack the permission. */
  redirectTo?: string
}

/**
 * Route guard keyed on a backend permission code. Cosmetic — the API still
 * enforces the real 403 boundary.
 */
export default function RequirePermission({
  permission,
  children,
  redirectTo = '/dashboard',
}: RequirePermissionProps) {
  const { hasPermission, loading } = useAuth()
  if (loading) return null
  if (!hasPermission(permission)) return <Navigate to={redirectTo} replace />
  return <>{children}</>
}
